<template>
  <div v-if="incidents.length">
    <h1>{{ title }}</h1>
    <ul id="incident-list">
      <li v-for="incident in incidents" :key="incident.id" class="incident">
        <div class="incident-header">
          <p class="incident-name">
            <a
              :href="incidentUrl(incident)"
              target="_blank"
              rel="noopener noreferrer"
              class="incident-link-icon"
              :aria-label="`More info about: ${incident.name}`"
            />
            <a
              :href="incidentUrl(incident)"
              target="_blank"
              rel="noopener noreferrer"
              class="incident-link"
              :aria-label="`More info about: ${incident.name}`"
            >
              {{ incident.name }}
            </a>
          </p>
          <p class="incident-date">
            <template
              v-if="incident.impact === 'maintenance'
                && incident.scheduled_for && incident.scheduled_until"
            >
              Scheduled for: {{ formatDateTime(incident.scheduled_for) }}
              until {{ formatDateTime(incident.scheduled_until) }} AEST
            </template>
            <template v-else>
              Last updated: {{ formatDateTime(incident.updated_at) }} AEST
            </template>
          </p>
        </div>
        <p>
          <span class="incident-status-label">Status: </span>
          <span>{{ convertToTitleCase(incident.status) }}</span>
        </p>
        <!-- Grab the most recent update -->
        <p class="incident-body" v-text="incident.incident_updates[0].body"/>
      </li>
    </ul>
  </div>
  <div v-else-if="noIncidentsText">
    <h1>{{ title }}</h1>
    <p class="incident">
      {{ noIncidentsText }}
    </p>
  </div>
</template>

<script>
import moment from 'moment-mini';

export default {
  props: {
    incidents: {
      required: true,
      type: Array
    },
    noIncidentsText: {
      default: '',
      type: String
    },
    title: {
      required: true,
      type: String
    }
  },
  methods: {
    convertToTitleCase(string) {
      const words = string.replace(/_/g, ' ').toLowerCase().split(' ');
      for (let i = 0; i < words.length; i += 1) {
        words[i] = words[i].charAt(0).toUpperCase() + words[i].slice(1);
      }
      return words.join(' ');
    },
    formatDateTime(date) {
      return moment(date).format('MMM DD, HH:mm');
    },
    incidentUrl(incident) {
      return `https://qvalent.statuspage.io/incidents/${incident.id}`;
    }
  }
};
</script>

<style lang="scss">
  .incident {
    .incident-body {
      white-space: pre-wrap;
    }

    .incident-link {
      color: $qv-yellow;
      font-size: 1.3rem;
      margin-left: 5px;
    }

    .incident-header {
      @media (max-width: 1330px) {
        flex-direction: column;
      }

      border-bottom: 1px solid $qv-yellow;
      display: flex;
      justify-content: space-between;
      margin-bottom: 1rem;
      padding-bottom: 5px;
      width: 100%;

      > * {
        color: $qv-yellow;
        margin-bottom: 0;
      }
    }

    .incident-status-label {
      font-weight: bold;
    }

    .incident-date {
      @media (min-width: 1331px) {
        padding-left: 10px;
      }

      flex-shrink: 0;
    }

    p {
      text-align: left;
    }
  }

  .incident-link-icon {
    background-image: url('../assets/img/icon-link.svg');
    display: inline-block;
    height: 24px;
    transform: rotate(-45deg);
    transform-origin: 44% 44% 0;
    vertical-align: top;
    width: 24px;
  }
</style>
